import partnerData from './partner-data';
import userData from './user-data';
import userPreferences from './user-preferences';

export default {
  partnerData,
  userData,
  userPreferences,
};
